export const catalogOptions = {
  title: {
    default: 'Vi-Killer',
    ko: '바이킬러',
  },
  langSet: ['ko', 'en'],
  pageMap: [
    'Cover',
    'Index',
    'Hybrid_what',
    'Hybrid_ness',
    'Hybrid_how',
    'Hybrid_diff',
    'Hybrid_strength',
    'Hybrid_app1',
    'Hybrid_app2',
    'Hybrid_app3',
    'Hybrid_app4',
    'Tech_disease_block',
    'Tech_report',
    'Tech_sterilize_1',
    'Tech_sterilize_2',
    'VK_cover',
    'VK_intro',
    'VK_strength',
    'VK_free',
    'VK_jumbo',
    'VK_mini',
    'VK_cert',
    'VTX_cover',
    'VTX_intro',
    'VTX_app',
    'Deger_intro',
    'Deger_safe',
    'Deger_range',
    'Deger_cert',
    'Last',
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 920,
  responsiveMode: true,
  breakpoint: 768,
};
